import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'antd'
import classNames from 'classnames'
import DOMPurify from 'dompurify'

import backIcon from 'assets/images/toolbar-back.svg'

import styles from './style.module.scss'

interface NoteDetailProps {
  note: string
  onClose: () => void
}

const NoteDetail = ({ note, onClose }: NoteDetailProps) => {
  const { t } = useTranslation()

  const urlify = (text: string): string => {
    const urlRegex = /(https?:\/\/[^\s]+)/g
    return text.replace(urlRegex, function (url) {
      return '<a href="' + url + '" target="_blank">' + url + '</a>'
    })
  }
  const linkifyNote = urlify(note)

  const renderHeader = () => {
    const titleElem = (
      <React.Fragment>
        <Button
          type="text"
          icon={<img src={backIcon} alt="Back" />}
          className={classNames(styles.backButton, 'backButton')}
          onClick={onClose}
        />
        <h2>{t('calendar.detail.note')}</h2>
      </React.Fragment>
    )

    return (
      <div className={styles.header}>
        <div className={styles.title}>{titleElem}</div>
      </div>
    )
  }

  const renderContent = () => {
    return (
      <div className={styles.content}>
        <div
          className={styles.noteContent}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`<p>${linkifyNote}</p>`) }}
        />
      </div>
    )
  }

  const renderFooter = () => {
    return (
      <div className={styles.footer}>
        <button className={styles.closeBtn} onClick={onClose}>
          {t('common.button.close')}
        </button>
      </div>
    )
  }

  return (
    <div className={styles.noteDetail}>
      {renderHeader()}
      {renderContent()}
      {renderFooter()}
    </div>
  )
}

export default NoteDetail
